// extracted by mini-css-extract-plugin
export default {"messageInput":"FC26E","giverNameContainer":"oZzcS"};